export default __webpack_public_path__ + "static/media/BrainBreak cards26.7bdeccd7.png";